import { track } from "./api";

const GOLD = "#D4AF37";

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

export const shareCricketWin = async (s) => {
  await Promise.all([
    document.fonts.load("800 110px Outfit"),
    document.fonts.load("700 30px Manrope"),
  ]).catch(() => {});
  const mascot = await loadImg(`/cricket/${s.team === "regal" ? "regal" : "urban"}_bat.png`).catch(() => null);
  const W = 1080, H = 1350;
  const c = document.createElement("canvas");
  c.width = W;
  c.height = H;
  const x = c.getContext("2d");
  x.fillStyle = "#0A0705";
  x.fillRect(0, 0, W, H);
  const glow = x.createRadialGradient(540, 560, 80, 540, 560, 720);
  glow.addColorStop(0, "rgba(240,199,66,0.22)");
  glow.addColorStop(1, "rgba(240,199,66,0)");
  x.fillStyle = glow;
  x.fillRect(0, 0, W, H);
  x.strokeStyle = GOLD;
  x.lineWidth = 6;
  x.strokeRect(40, 40, W - 80, H - 80);
  x.lineWidth = 1.5;
  x.strokeStyle = "rgba(212,175,55,0.5)";
  x.strokeRect(58, 58, W - 116, H - 116);
  x.textAlign = "center";
  x.fillStyle = GOLD;
  x.font = "600 30px Manrope, sans-serif";
  x.fillText("U R B A N   A R C A D E   ·   P U N J A B   M E L A", 540, 140);
  x.fillStyle = "#FFFFFF";
  x.font = "800 64px Outfit, sans-serif";
  x.fillText("URBAN vs REGAL", 540, 232);
  x.fillStyle = "rgba(255,255,255,0.55)";
  x.font = "700 26px Manrope, sans-serif";
  x.fillText("C R I C K E T   C L A S H", 540, 274);
  if (mascot) {
    const mh = 520, mw = mh * (mascot.width / mascot.height);
    x.shadowColor = "rgba(0,0,0,0.6)";
    x.shadowBlur = 40;
    x.shadowOffsetY = 22;
    x.drawImage(mascot, 540 - mw / 2, 320, mw, mh);
    x.shadowColor = "transparent";
    x.shadowBlur = 0;
    x.shadowOffsetY = 0;
  }
  x.fillStyle = GOLD;
  x.font = "800 92px Outfit, sans-serif";
  x.fillText("VICTORY!", 540, 952);
  x.fillStyle = "#FFFFFF";
  x.font = "800 110px Outfit, sans-serif";
  x.fillText(`${s.score} / ${s.target}`, 540, 1078);
  x.fillStyle = "rgba(255,255,255,0.65)";
  x.font = "700 30px Manrope, sans-serif";
  x.fillText(`FOURS ${s.fours}   ·   SIXES ${s.sixes}   ·   PERFECT ${s.perfects}`, 540, 1142);
  x.fillStyle = GOLD;
  x.font = "700 26px Manrope, sans-serif";
  x.fillText(`TEAM ${s.team === "regal" ? "REGAL" : "URBAN"} · ${(s.difficulty || "").toUpperCase()}`, 540, 1196);
  x.fillStyle = "rgba(255,255,255,0.4)";
  x.font = "600 24px Manrope, sans-serif";
  x.fillText("PLAY AT THE URBAN ARCADE · MYURBANPASSPORT.COM", 540, 1262);
  track("cricket_share", { score: s.score, team: s.team, difficulty: s.difficulty });
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const file = new File([blob], "urban-cricket-win.png", { type: "image/png" });
  if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "Cricket Clash — Urban by VeerGi" });
      return "shared";
    } catch { /* fall back to download */ }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "urban-cricket-win.png";
  a.click();
  return "downloaded";
};

const drawBadge = (title, subtitle, kind) => {
  const c = document.createElement("canvas");
  c.width = 1080;
  c.height = 1080;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#050505";
  ctx.fillRect(0, 0, 1080, 1080);
  // subtle radial glow
  const g = ctx.createRadialGradient(540, 480, 60, 540, 480, 640);
  g.addColorStop(0, "rgba(212,175,55,0.16)");
  g.addColorStop(1, "rgba(212,175,55,0)");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 1080, 1080);
  // double border
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 6;
  ctx.strokeRect(40, 40, 1000, 1000);
  ctx.lineWidth = 1.5;
  ctx.strokeStyle = "rgba(212,175,55,0.5)";
  ctx.strokeRect(58, 58, 964, 964);
  ctx.textAlign = "center";
  // header
  ctx.fillStyle = GOLD;
  ctx.font = "600 34px Manrope, sans-serif";
  ctx.fillText("U R B A N   D Y N A S T Y", 540, 150);
  ctx.fillStyle = "rgba(255,255,255,0.45)";
  ctx.font = "500 24px Manrope, sans-serif";
  ctx.fillText(kind, 540, 205);
  // medallion
  ctx.beginPath();
  ctx.arc(540, 400, 110, 0, Math.PI * 2);
  ctx.strokeStyle = GOLD;
  ctx.lineWidth = 4;
  ctx.stroke();
  ctx.fillStyle = GOLD;
  ctx.font = "700 100px 'Cormorant Garamond', serif";
  ctx.fillText("ਉ", 540, 438);
  // title (wrapped)
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "700 76px 'Cormorant Garamond', serif";
  const words = title.split(" ");
  const lines = [];
  let line = "";
  words.forEach((w) => {
    if (ctx.measureText(line + " " + w).width > 860 && line) {
      lines.push(line);
      line = w;
    } else line = line ? line + " " + w : w;
  });
  lines.push(line);
  lines.forEach((l, i) => ctx.fillText(l, 540, 620 + i * 86));
  // subtitle
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.font = "400 30px Manrope, sans-serif";
  ctx.fillText(subtitle.slice(0, 60), 540, 640 + lines.length * 86 + 20);
  // footer
  ctx.fillStyle = GOLD;
  ctx.font = "600 26px Manrope, sans-serif";
  ctx.fillText("URBAN BY VEERGI", 540, 960);
  ctx.fillStyle = "rgba(255,255,255,0.4)";
  ctx.font = "400 22px Manrope, sans-serif";
  ctx.fillText("EAT. EXPLORE. LEARN. EARN. RETURN. · tryurbanturban.com", 540, 1000);
  return c;
};

export const shareBadge = async (title, subtitle, kind = "ACHIEVEMENT UNLOCKED") => {
  try {
    await document.fonts.ready;
  } catch {}
  const canvas = drawBadge(title, subtitle, kind);
  track("badge_shared", { title, kind });
  const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
  const file = new File([blob], "urban-badge.png", { type: "image/png" });
  if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: `${title} — Urban by VeerGi` });
      return "shared";
    } catch {}
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `urban-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.png`;
  a.click();
  URL.revokeObjectURL(a.href);
  return "downloaded";
};
